document.addEventListener('DOMContentLoaded', function() {
  // Email Links
  var emailLinks = document.querySelectorAll('a[href^="mailto:"]');
  emailLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      gtag_report_conversion();
      return true;
    });
  });

  // Phone Links
  var phoneLinks = document.querySelectorAll('a[href^="tel:"]');
  phoneLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      gtag_report_conversion();
      return true;
    });
  });

  // SMS Links (Assuming they also use "tel:")
  var smsLinks = document.querySelectorAll('a[href^="sms:"]');
  smsLinks.forEach(function(link) {
    link.addEventListener('click', function() {
      gtag_report_conversion();
      return true;
    });
  });

  // WhatsApp Button (Using Class)
  var whatsappButton = document.querySelector('.whatsappIcon'); 
  if (whatsappButton) {
    whatsappButton.addEventListener('click', function() {
      gtag_report_conversion();
      return true;
    });
  }
});